import axios from "../axiosPlugin.js";

const _CLIENT_API = "/api/client";
const _CLIENT_GROUP_API = "/api/clientGroup";

/* Client services */
export const getClientListService = data => {
  return axios({
    url: `${_CLIENT_API}/list`,
    method: "get",
    data: { data },
  });
};

export const delClientService = data => {
  return axios({
    url: `${_CLIENT_API}/delete/${data.cid}`,
    method: "get",
    data: { data },
  });
};

export const addClientService = data => {
  return axios({
    url: `${_CLIENT_API}/create`,
    method: "post",
    data: { data },
  });
};

export const updateClientService = data => {
  return axios({
    url: `${_CLIENT_API}/update`,
    method: "post",
    data: { data },
  });
};

export const clientDetailService = data => {
  return axios({
    url: `${_CLIENT_API}/detail/${data.id}`,
    method: "get",
    data: { data },
  });
};

/* Client Group services */
export const getClientGroupListService = data => {
  return axios({
    url: `${_CLIENT_GROUP_API}/list`,
    method: "get",
    data: { data },
  });
};

export const delClientGroupService = data => {
  return axios({
    url: `${_CLIENT_GROUP_API}/delete/${data.gid}`,
    method: "get",
    data: { data },
  });
};

export const addClientGroupService = data => {
  return axios({
    url: `${_CLIENT_GROUP_API}/create`,
    method: "post",
    data: { data },
  });
};

export const updateClientGroupService = data => {
  return axios({
    url: `${_CLIENT_GROUP_API}/update`,
    method: "post",
    data: { data },
  });
};

export const clientDetailGroupService = data => {
  return axios({
    url: `${_CLIENT_GROUP_API}/detail/${data.id}`,
    method: "get",
    data: { data },
  });
};

export const clientExportService = () => {
  return axios({
    url: `${_CLIENT_API}/export`,
    method: "get",
    data: {}
  });
};